import { getKeyValidationErrors } from './validation.js';

const requiredDraftOrderKeys = {
  officeID: true,
  id: true
};
/**
 * Determine whether an object of type DraftOrderNew meets all requirements
 * to be saved as DraftOrderWithOfficeID.
 */

const isDraftOrderValid = draftOrder => !getKeyValidationErrors(draftOrder, requiredDraftOrderKeys);
const getValidatedDraftOrder = draftOrder => {
  if (!isDraftOrderValid(draftOrder)) {
    throw Error(`DraftOrderNew does not pass validation:
      ${getKeyValidationErrors(draftOrder, requiredDraftOrderKeys)}`);
  }

  return draftOrder;
};

export { getValidatedDraftOrder, isDraftOrderValid };
